export const headCells= [
                    {
                      id: "fullName",
                      numeric: false,
                      disablePadding: false,
                      label: "User Name",
                    },
                    {
                      id: "activeStatus",
                      numeric: true,
                      disablePadding: false,
                      label: "Status",
                    },
                    {
                      id: "email",
                      numeric: true,
                      disablePadding: false,
                      label: "Email",
                    },
                    {
                      id: "phoneNumber",
                      numeric: true,
                      disablePadding: false,
                      label: "Phone",
                    },
                    {
                      id: "roleId",
                      numeric: true,
                      disablePadding: false,
                      label: "Role",
                    },
                    {
                      id: "action",
                      numeric: true,
                      disablePadding: false,
                      label: "Action",
                    },
                  ];